<template>
  <v-row no-gutters>
    <v-col v-if="appStore.isCustomer" class="delayEl">
      <CustomerAlert />
    </v-col>
    <v-col v-else>
      <div id="extract-list" :class="{ 'page-fullscreen': pageStore.isFullScreen }">
        <v-card
          tile
          :disabled="store.cardDisabled"
          :class="$vuetify.breakpoint.mdAndDown ? null : 'rounded-t-xl'"
        >
          <PageHeader />

          <v-data-table
            :headers="store.tableColumns"
            :items="store.tableItems"
            :loading="store.tableLoading"
            :height="pageStore.tableHeight"
            loader-height="2"
            :items-per-page="-1"
            :mobile-breakpoint="100"
            fixed-header
            hide-default-footer
            :class="{
              'extract-fixed-footer':
                !store.tableLoading &&
                !store.isError &&
                store.tableSearch_1 === '' &&
                store.tableSearch_2 === '' &&
                store.tableSearch_3 === '',
            }"
          >
            <!-- Arama Alanı -->
            <template v-slot:body.prepend>
              <tr style="zoom: 0.8; position: sticky; z-index: 2; top: 40px; background: #363351">
                <!-- Belge Tipi -->
                <td class="pa-0">
                  <v-text-field
                    v-model="store.tableSearch_1"
                    :prepend-inner-icon="icons.mdiMagnify"
                    persistent-placeholder
                    clearable
                    placeholder="Ara"
                    filled
                    class="rounded-0 elevation-0"
                    hide-details
                  />
                </td>

                <!-- Belge No -->
                <td class="pa-0">
                  <div class="d-flex">
                    <v-text-field
                      v-model="store.tableSearch_2"
                      :prepend-inner-icon="icons.mdiMagnify"
                      persistent-placeholder
                      clearable
                      placeholder="Ara"
                      filled
                      class="rounded-0 elevation-0"
                      hide-details
                    />
                  </div>
                </td>
                <!-- Açıklama -->
                <td class="pa-0">
                  <div class="d-flex">
                    <v-text-field
                      v-model="store.tableSearch_3"
                      :prepend-inner-icon="icons.mdiMagnify"
                      persistent-placeholder
                      clearable
                      placeholder="Ara"
                      filled
                      class="rounded-0 elevation-0"
                      hide-details
                    />
                  </div>
                </td>

                <!-- Boş -->
                <td
                  class="pa-0"
                  v-for="item in store.tableEmptySearch"
                  :key="`emptySearch-${item}`"
                >
                  <v-text-field filled disabled class="rounded-0 elevation-0" hide-details />
                </td>
              </tr>
            </template>

            <!-- Belge Tipi -->
            <template #[`item.FINDOCTYPE`]="{ item }">
              <v-chip label color="chip" class="d-flex justify-center">
                <div
                  class="text-truncate text-uppercase data-table-item-type-one"
                  style="width: 40px !important"
                >
                  {{ item.FINDOCTYPE ? item.FINDOCTYPE : "-" }}
                </div>
              </v-chip>
            </template>

            <!-- Belge No -->
            <template #[`item.EXTINVNUM`]="{ item }">
              <v-chip color="grey" class="d-flex justify-center" label>
                <div class="text-truncate data-table-item-type-one" style="width: 120px !important">
                  {{ item.EXTINVNUM ? item.EXTINVNUM : "-" }}
                </div>
              </v-chip>
            </template>

            <!-- Açıklama -->
            <template #[`item.LINEDESC`]="{ item }">
              <div class="d-flex align-center">
                <div>
                  <div class="text-subtitle-2 white--text text-capitalize text-no-wrap">
                    {{ item.ACCNAME }}
                  </div>
                  <div class="text-caption text--disabled text-no-wrap">
                    {{ item.LINEDESC }}
                  </div>
                </div>
              </div>
            </template>

            <!-- Vade Tarih -->
            <template #[`item.CURRDATE`]="{ item }">
              <v-tooltip color="chip" bottom v-if="item.CURRDATE">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip color="" class="d-flex justify-center" label v-bind="attrs" v-on="on">
                    <div
                      class="text-truncate d-flex align-center data-table-item-type-one"
                      style="width: 100px !important"
                    >
                      <v-icon color="" small class="mr-2">
                        {{ icons.mdiCalendar }}
                      </v-icon>
                      <div class="mr-1">
                        {{ item.CURRDATE }}
                      </div>
                    </div>
                  </v-chip>
                </template>
                <div>
                  {{ item.CURRDATE }}
                </div>
              </v-tooltip>
            </template>

            <!-- Borç -->
            <template #[`item.DDEBIT`]="{ item }">
              <div v-if="item.DDEBIT" class="text-caption font-weight-medium">
                {{ item.DDEBIT | currency({ symbol: "" }) }}
              </div>
            </template>

            <!-- Alacak -->
            <template #[`item.DCREDIT`]="{ item }">
              <div v-if="item.DCREDIT" class="text-caption font-weight-medium">
                {{ item.DCREDIT | currency({ symbol: "" }) }}
              </div>
            </template>

            <!-- Bakiye -->
            <template #[`item.DCURRBAL`]="{ item }">
              <div v-if="item.DCURRBAL" class="text-caption white--text font-weight-medium">
                {{ item.DCURRBAL | currency({ symbol: "" }) }}
              </div>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { onMounted, onUnmounted, watch } from "vue-demi";

// Pinia
import { useExtarctStore } from "./_store";
import { useAppStore } from "@/stores/app";
import { usePageStore } from "@/stores/pageHeader";

// Components
import PageHeader from "@/components/PageHeader/Index.vue";
import CustomerAlert from "@/components/CustomerAlert.vue";

// Icons
import { mdiTrayFull, mdiMagnify, mdiCalendar } from "@mdi/js";

export default {
  components: {
    PageHeader,
    CustomerAlert,
  },
  setup() {
    // Pinia bağlantıları
    const store = useExtarctStore();
    const appStore = useAppStore();
    const pageStore = usePageStore();

    // Sayfa Özellikleri
    const pageSettings = () => {
      pageStore.pageTitle = "Ekstre";
      pageStore.pageIcon = mdiTrayFull;
      pageStore.hasFullScreen = true;
      pageStore.hasDownload = true;
      pageStore.hasDateRange = true;
      pageStore.hasActions = false;

      pageStore.downloadHeader = {
        "Belge Tipi": "FINDOCTYPE",
        "Belge No": "EXTINVNUM",
        Açıklama: "LINEDESC",
        "Vade Tarihi": "CURRDATE",
        "Borç (TL)": "DDEBIT",
        "Alacak (TL)": "DCREDIT",
        "Bakiye (TL)": "DCURRBAL",
      };
    };

    // Müşteri seçimi gerekiyorsa değişiklikler izleniyor
    watch(
      () => appStore.selectedCustomer,
      (newVal, oldVal) => {
        if (!appStore.isCustomer) {
          store.tableFetch(pageStore.dateRange);
        }
      }
    );

    // Tarih aralığı için değişiklikler izleniyor
    watch(
      () => pageStore.dateRange,
      (newVal, oldVal) => {
        if (!appStore.isCustomer) {
          store.tableFetch(newVal);
        }
      }
    );

    onMounted(() => {
      pageSettings();

      if (appStore.isCustomer) return;

      store.tableFetch(pageStore.dateRange);
    });

    onUnmounted(() => {
      pageStore.pageSettingsClear();
    });

    return {
      // Pinia
      store,
      appStore,
      pageStore,

      // icons
      icons: {
        mdiTrayFull,
        mdiMagnify,
        mdiCalendar,
      },
    };
  },
};
</script>
<style lang="scss">
.extract-fixed-footer {
  tbody {
    tr {
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4),
      &:nth-child(5) {
        td {
          &:nth-child(1),
          &:nth-child(2),
          &:nth-child(4) {
            span {
              opacity: 0;
            }
          }
        }
      }
      &:nth-last-of-type(2) {
        position: sticky;
        bottom: 0;
        background: #3b355a !important;
        td {
          border-top: thin solid rgba(231, 227, 252, 0.14);
          &:nth-child(1),
          &:nth-child(2),
          &:nth-child(4) {
            span {
              opacity: 0;
            }
          }
        }
      }
      &:nth-last-of-type(1) {
        background: #3b355a !important;
        td {
          &:nth-child(1),
          &:nth-child(2),
          &:nth-child(4) {
            span {
              opacity: 0;
            }
          }
        }
      }
    }
  }
}
</style>
